@if(!task.error){
    <div class="d-flex justify-content-between task-content mx-auto">
        <i [matTooltip]="task.date | date: 'mediumDate'" matTooltipPosition="above">{{task.date | date_time_from_now }}</i>
        <div class="d-flex">
            <span class="badge rounded-pill text-bg-light">{{task.team.name}}</span>
            <a class="text-secondary ms-2" 
                [matTooltip]="'taskbook.task.view_on_timeline' | translate" matTooltipPosition="above" 
                [routerLink]="['/timeline', task.team.id]" [queryParams]="{focus: task.id}" target="_blank">
                <i class="fas fa-arrow-up-right-from-square"></i>
            </a>
        </div>
    </div>
    <div class="media card my-1 pt-2 pb-0 task-content" 
            [ngClass]="{'topic-card': task.itemType == 'topicItem', 'kudos-card': task.itemType == 'kudosItem', 'streaks-card-wrapper': task.itemType == 'badMoodStreakItem', 'focus-task': threadInCreation}" 
            id="{{task.id}}">        
        @switch(task.itemType){
            @case('moodItem'){
                <mood-task [task]="($any(task))"
                            (onReported)="onReported()"></mood-task>
            }
            @case('kudosItem'){
                <kudos-task [task]="($any(task))"
                            (onReported)="onReported()"></kudos-task>
            }
            @case('topicItem'){
                <topic-task [task]="($any(task))"
                            (onReported)="onReported()"></topic-task>
            }
            @case('badMoodStreakItem'){
                <bad-mood-streak-task [task]="($any(task))"></bad-mood-streak-task>
            }
            @case('agreeDisagreeQuestionResultItem'){
                <poll-result-task [task]="($any(task))"
                                    (onReported)="onReported()"></poll-result-task>
            }
            @case('closedQuestionResultItem'){
                <poll-result-task [task]="($any(task))"
                                    (onReported)="onReported()"></poll-result-task>
            }
            @case('scaleQuestionResultItem'){
                <scale-poll-result-task [task]="($any(task))"
                                        (onReported)="onReported()"></scale-poll-result-task>
            }
            @case('fiveStarsQuestionResultItem'){
                <five-stars-poll-result-task [task]="($any(task))"
                                                (onReported)="onReported()"></five-stars-poll-result-task>
            }
        }
            <div class="media-bottom card-bottom" [ngClass]="threadInCreation ? 'pb-4' : 'pb-2'">
                <tm-reactions [timelineItem]="task"
                                [showDiscussButton]="true"
                                (onDiscuss)="discuss()"
                                (onReacted)="onReacted($event)"/>
                <tm-task-threads [task]="task" #threadsComponent
                                    [userInfos]="userInfos"
                                    [threadInCreation]="threadInCreation"
                                    (onThreadFocus)="discuss()"
                                    (onCancelCreation)="onCancelCreation()"
                                    (onThreadCreation)="onThreadCreation($event)"></tm-task-threads>
            </div>
        
    </div>
}
